import { Card, CardContent } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import {
  FilterList,
  FilterListItem,
  FilterLiveSearch,
  SavedQueriesList,
  useGetList,
  useListContext,
} from 'react-admin';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../constants';
import { fetchUtils } from 'react-admin';

const fetchJson = (url: string, options = {}) => {
  const token = localStorage.getItem('auth') as string;
  return fetchUtils.fetchJson(url, {
    ...options,
    user: {
      authenticated: !!token,
      token,
    },
  });
};

const BillerMerchantCodeMappingAside = () => {
  const { filterValues, setFilters, displayedFilters } = useListContext();
  const [billerCategories, setBillerCategories] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const { data: billerMerchantCodes, isLoading: isMerchantCodesLoading } = useGetList(
    'billerMerchantCodes',
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: 'merchantCode', order: 'ASC' },
    }
  );

  // Fetch biller categories from API
  useEffect(() => {
    setIsLoading(true);
    fetchJson(`${apiUrl}/billerCategory`)
      .then(({ json }) => {
        let categories = [];
        if (Array.isArray(json)) {
          categories = json;
        } else if (json.data && Array.isArray(json.data)) {
          categories = json.data;
        }
        setBillerCategories(categories);
      })
      .catch((err) => {
        console.error('Error fetching biller categories:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  // Transform merchant codes for display
  const merchantCodesList = billerMerchantCodes?.map((mc: any) => ({
    id: mc.merchantCode || mc.id,
    code: mc.merchantCode || mc.merchantId || mc.id,
    details: mc.details || mc.merchantId || mc.id,
  })) || [];

  return (
    <Card
      sx={{
        order: -1,
        flex: '0 0 15em',
        mr: 2,
        mt: 6,
        alignSelf: 'flex-start',
        height: '85vh',
        overflowY: 'auto',
      }}
    >
      <CardContent sx={{ pt: 1 }}>
        <SavedQueriesList />

        <FilterList label="Biller Category" icon={<CategoryIcon />}>
          {!isLoading &&
            billerCategories.map((category) => (
              <FilterListItem
                key={category.categoryId}
                label={category.categoryName}
                value={{ categoryId: category.categoryId }}
              />
            ))}
        </FilterList>

        <FilterList label="Merchant Code" icon={<CurrencyRupeeIcon />}>
          {!isMerchantCodesLoading &&
            merchantCodesList.map((merchantCode) => (
              <FilterListItem
                key={merchantCode.id}
                label={merchantCode.details}
                value={{ merchantCode: merchantCode.code }}
              />
            ))}
        </FilterList>
      </CardContent>
    </Card>
  );
};

export default BillerMerchantCodeMappingAside;
